import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Typography, Button, Box, useTheme } from "@mui/material";

const InfoDialog = ({ openByDefault = true }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(openByDefault);

  useEffect(() => {
    setOpen(true); // ✅ Opens automatically on page load/refresh
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperProps={{
        sx: {
          backgroundColor: "#1f1a24",
          color: theme.palette.text.primary,
          padding: 2,
          borderRadius: 0,
          boxShadow: theme.shadows[2],
          maxWidth: "25%",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: "bold" }}>Welcome to AVA Wiki Trends</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          This app tracks interest in American Viticultural Areas (AVAs) based on Wikipedia page views. 
          Select states and AVAs to explore their trends over time. Click 'Analyze' to derive insights from selected data.
        </Typography>

        {/* ✅ Centered Button */}
        <Box sx={{ display: "flex", justifyContent: "right", mt: 3 }}>
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              backgroundColor: "#32283f",
              "&:hover": { backgroundColor: "#1f1a24" },
            }}
          >
            Let's go!
          </Button>
        </Box>

      </DialogContent>
    </Dialog>
  );
};

export default InfoDialog;
